module.exports = __webpack_public_path__ + "img/MR_placeholder_400x400.2c247b38.png";